const gifs = {
    bug: require('./bug.gif'),
    nerd: require('./nerd.gif'),
    wave: require('./wave.gif')
}

module.exports = gifs
